<!--
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-12-07 18:46:10
-->
<template>
  <div id="app" ref="container">
    <div class="pageBg">
      <pageTop v-if="pageWidth == '1336px'" />
      <div class="pageTop" v-if="pageWidth == '1336px'">
        <img src="../src/assets/imgs/topBg.png" alt="" class="bigBg" />
      </div>
      <div
        style="margin: 0 auto;min-height:80vh;padding: 0 18px;box-sizing: border-box;"
        :style="{ width: pageWidth }"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// import Watermark from "./utils/watermark";
import pageTop from "../src/components/page_top.vue";
export default {
  components: {
    pageTop
  },
  name: "App",
  data() {
    return {
      pageWidth: "1336px"
    };
  },
  created: function() {
    // Watermark.set("水印内容", this.$refs.container);
    if (this.$route.path == "/login") {
      this.pageWidth = "100%";
    } else {
      this.pageWidth = "1336px";
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "login") {
        this.pageWidth = "100%";
      } else {
        this.pageWidth = "1336px";
      }
    }
  }
};
</script>

<style>
#app {
  color: #000;
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  overflow: hidden;
  font-family: PingFangSC-Regular, PingFang SC;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
  background: #f7f8fc;
  font-family: PingFangSC-Regular, PingFang SC;
}
.pageTop {
  width: 100%;
  height: 197px;
  background: linear-gradient(180deg, #e4eeff 0%, #f7f8fc 100%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.pageBg {
  position: relative;
  width: 100%;
  min-height: 100vh;
}
.bigBg {
  display: block;
  width: 1336px;
  height: 100%;
  margin: 0 auto;
}

/* 全局公共样式 */
.cardTitle {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303a49;
  line-height: 18px;
}
.pageBox {
  width: 100%;
  min-height: 80vh;
}
.omit {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* 列表页面的右侧盒子 */
.pageTab {
  width: 1088px;
  min-height: 80%;
  background: #ffffff;
  border-radius: 8px;
  height: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  margin-top: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
}
/* 添加页面的右侧盒子 */
.pageTabAdd {
  width: 100%;
  min-height: 80%;
  margin-top: 12px;
  height: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
}
.content {
  display: flex;
  min-height: 80vh;
  font-family: PingFangSC-Regular, PingFang SC;
}

.pageSelectTitle {
  display: flex;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #303a49;
  line-height: 19px;
}
.pageSelectTitleItem {
  margin-right: 24px;
  position: relative;
}
.titleActive {
  color: #165dff;
}
.titleActive::after {
  content: "";
  position: absolute;
  top: 30px;
  right: 10%;
  width: 42px;
  height: 3px;
  background: #165dff;
  border-radius: 2px;
}
.breadcrumb {
  margin-bottom: 13px;
}
.el-table th.el-table__cell {
  background: #f9f9fa !important;
}
.btn {
  background: #165dff;
  color: #fff;
}
.btn.el-button:hover {
  background: #165dff !important;
  color: #fff !important;
}
/* 添加页面的右侧卡片 */
.box-card {
  height: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
}
.el-pagination {
  text-align: center !important;
  margin: 20px auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
.el-dialog {
  border-radius: 8px !important;
}
.el-dialog__header {
  border-bottom: solid 1px #e8ecef;
}
.disAround {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.operateBtn {
  flex: none;
  cursor: pointer;
  color: #2c68ff;
  margin-right: 10px;
}
.el-dialog__body {
  padding: 30px 50px !important;
}
.el-form-item__content {
  display: flex;
  margin-left: 0 !important;
}

/* 字体 */
.decoration {
  text-decoration: underline;
  color: #165dff;
  display: inline-block;
  /* border-bottom: #165dff 2px solid; */
}
.el-table th.el-table__cell > .cell {
  text-align: center;
}
.el-table .cell {
  text-align: center;
}
.redColor {
  color: red;
  cursor: pointer;
  background: rgb(255, 0, 0, 0.1);
  padding: 3px 12px 3px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  font-size: 12px;
  position: relative;
}
.redColor::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: red;
  position: absolute;
  top: 40%;
  left: 16%;
}
.yllColor {
  color: #efd407;
  cursor: pointer;
  background: rgb(255, 0, 0, 0.1);
  padding: 3px 12px 3px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  font-size: 12px;
  position: relative;
}
.yllColor::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: #efd407;
  position: absolute;
  top: 40%;
  left: 16%;
}
.greenColor {
  color: rgb(25, 185, 25);
  cursor: pointer;
  background: rgb(25, 185, 25, 0.1);
  padding: 3px 12px 3px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  font-size: 12px;
  position: relative;
}
.greenColor::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: rgb(25, 185, 25);
  position: absolute;
  top: 40%;
  left: 16%;
}
.blueColor {
  color: rgb(46, 46, 240);
  cursor: pointer;
  background: rgb(46, 46, 240, 0.1);
  padding: 3px 12px 3px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  font-size: 12px;
  position: relative;
}
.blueColor::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: rgb(46, 46, 240);
  position: absolute;
  top: 40%;
  left: 16%;
}
.yellowColor {
  color: yellow;
  cursor: pointer;
  background: #fadc19;
  padding: 3px 12px 3px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  font-size: 12px;
  position: relative;
}
.yellowColor::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: yellow;
  position: absolute;
  top: 40%;
  left: 16%;
}
.blueColor1 {
  color: rgb(46, 46, 240);
  cursor: pointer;
}
.greenColor1 {
  color: rgb(25, 185, 25);
  cursor: pointer;
}
.redColor1 {
  color: red;
  cursor: pointer;
}
.yellowColor1 {
  color: yellow;
  cursor: pointer;
}
/* .el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: scroll !important;
} */
</style>
